import  { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Iron Mass Calculator - Calculate Iron Mass Based on Dimensions';
const DESCRIPTION = 'The Iron Mass Calculator calculates the mass of an iron piece based on the entered dimensions.';
const KEYWORDS = 'Iron mass, Calculate iron mass, Iron mass calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/iron-mass';
function Calculator() {
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [volume, setVolume] = useState('');
    const [ironMass, setIronMass] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!length || !width || !height) {
            setError('Please enter the dimensions correctly');
            setVolume('');
            setIronMass('');
            return;
        }
        const lengthValue = parseFloat(length);
        const widthValue = parseFloat(width);
        const heightValue = parseFloat(height);
        if (isNaN(lengthValue) || isNaN(widthValue) || isNaN(heightValue) || lengthValue <= 0 || widthValue <= 0 || heightValue <= 0) {
            setError('Please enter valid and positive values for the dimensions');
            setVolume('');
            setIronMass('');
            return;
        }
        const ironVolume = lengthValue * widthValue * heightValue;
        setVolume(ironVolume.toFixed(2));
        const mass = ironVolume * 7.8;
        setIronMass(mass.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{ fontSize: '18px' }}>How to Calculate Iron Mass</h2>
                                        <p>
                                            Iron mass can be calculated using the following formula:
                                        </p>
                                        <p>
                                            Mass = Density × Volume
                                        </p>
                                        <p>
                                            Where mass is the required mass of the iron piece (in grams),
                                            and the density for iron is typically 7.8 g/cm³.
                                        </p>
                                        <p>
                                            You should input the dimensions (length, width, and height) of the iron piece to calculate the volume,
                                            and then the mass will be calculated based on density and volume.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Length (cm)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Length"
                                                        value={length}
                                                        onChange={(e) => setLength(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Width (cm)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Width"
                                                        value={width}
                                                        onChange={(e) => setWidth(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Height (cm)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Height"
                                                        value={height}
                                                        onChange={(e) => setHeight(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Iron Mass
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {ironMass !== '' && (
                                                            <p className='p-3 mb-2 bg-success text-white'>
                                                                Iron Mass: {ironMass} grams
                                                            </p>
                                                        )}
                                                        {volume !== '' && (
                                                            <p className='p-3 mb-2 bg-success text-white'>
                                                                Iron Volume: {volume} cm³
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
        </div>
    );
}
export default Calculator;
